import { TranslationService } from "@sdbn/common";
import { Component, OnInit } from "@angular/core";
import { HttpService, ServiceResponse } from "@sdbn/appclient";
import { CameraDefinition, NumberPlateScan } from "../../yard-simulator.model";
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from "@angular/forms";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-number-plate-scan",
  templateUrl: "./number-plate-scan.component.html",
  styleUrls: ["./number-plate-scan.component.css"],
})
export class NumberPlateScanComponent implements OnInit {
  cameraSelected: CameraDefinition;
  cameras: CameraDefinition[];

  numberPlateNumber: string;

  formGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private service: HttpService
  ) {
    this.formGroup.addControl("numberPlateNumber", new FormControl("", []));
    this.formGroup.addControl("cameraSelection", new FormControl("", []));
    this.formGroup.valueChanges.subscribe((formValues) => {
      this.numberPlateNumber = formValues.numberPlateNumber;
    });
  }

  ngOnInit() {
    this.service
      .postWithContext<CameraDefinition[]>(
        environment.yardSimulatorAdminEntpoint + "/cameras",
        {}
      )
      .subscribe((cameras) => {
        this.cameras = cameras;
      });
  }

  onCameraSelection(camera: CameraDefinition) {
    this.cameraSelected = camera;
  }

  onButtonTrigger() {
    const numberPlateScan = new NumberPlateScan({
      identifier: this.cameraSelected.identifier,
      scannedNumber: this.numberPlateNumber,
    });

    this.service
      .postWithContext<ServiceResponse>(
        environment.yardSimulatorAdminEntpoint + "/number-plate-scan",
        numberPlateScan
      )
      .subscribe((response) => {
        console.log(response.status, ":\n", response.responseMessages);
      });
  }
}
